import "./ContentCard.scss";

import React from "react";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from "@mui/material";

import { ContentCardData } from "../../models/app-data-model";

export type ContentCardProps = {
  contentCardData: ContentCardData;
};

const ContentCard: React.FC<ContentCardProps> = ({ contentCardData }) => {
  const title = contentCardData.reference[0]?.seo?.nav_title;
  const button_label = contentCardData.button_label;
  const button_url = contentCardData.button_url;
  const date = contentCardData.date;
  const mock_category_name = "Employer";
  const mock_category_url = "/individual-family";

  return (
    <Card className="card">
      <CardContent className="card-content">
        <Typography variant="h4" className="content-title">
          {title}
        </Typography>
        {mock_category_name && <div className="content-category-date">
          <a className="content-category" href={mock_category_url} >{mock_category_name}</a>
          <span className="content-date">
            {date}
          </span></div>}
      </CardContent>
      <CardActions disableSpacing className="card-actions">
        <Button size="medium" variant="contained" className="action-button" title={title} href={button_url}>{button_label}</Button>
      </CardActions>
    </Card>
  );
};

export default ContentCard;

